$(document).ready(function(){
    $('.c-slider').slick({
      dots: false,
      //infinite: true, 
      autoplay: false, 
      slidesToShow:1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [ 
        {
          breakpoint: 768,
          settings: {
            dots: true, 
          }
        }  
      ]
    }); 
    
    $('.multi-modal').appendTo('.page-container'); 
    
    $("#vid-modal1").on("show.bs.modal", function () {
      $("#js-video")[0].play();
    });
    $("#vid-modal1").on("hide.bs.modal", function () {
      $("#js-video")[0].pause();
    });

    $(".c-scroll").click(function() {
       if (this.hashUrl !== "") { 
           // event.preventDefault(); 
            var hashUrl = this.hash; 
            $('html, body').animate({
              scrollTop: $(hashUrl).offset().top-0
            }, 500, function(){ 
              window.location.hashUrl = hashUrl;
            });
          } 
    });
    
     //$("#optinForm").modal("show");
     
    
      const cartItem = { 
          items:  [] 
       };
    
      const addItem = ({ variantId, quantity}) => {
        cartItem.items.push({
          id: variantId,
          quantity 
        });
      }
      const addBundleToCart = () => { 
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { items: mapItemToCart() }, 
          dataType: 'json',
          success: function(data) {  
            //theme.ajaxCart.update();   
             icartUpdateCartEvent();
            cartItem.items = []; 
          }
        });
      }
    
      const mapItemToCart = () => {  
        return cartItem.items.map(({ quantity, id: itemId, variantId }) => {
          const id = itemId;
          return {
            id,
            quantity 
          }
        });
      } 
    $('.c-add-cart').click((event) => { 
      event.preventDefault();  
      const element = $(event.target);
      const variantId = element.data("variant-id");
      const quantity = 1;
      addItem({ variantId, quantity: 1});   
       addBundleToCart();
      console.log(mapItemToCart());
    }); 

  });

    
    $(document).ready(function () {
      function setCookie(cname, cvalue, exdays) {
         var d = new Date();
         d.setTime(d.getTime() + (exdays*24*60*60*1000));
         var expires = "expires="+ d.toUTCString();
         document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
      function getCookie(cname) {
         var name = cname + "=";
         var decodedCookie = decodeURIComponent(document.cookie);
         var ca = decodedCookie.split(';');
         for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
               c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
               return c.substring(name.length, c.length);
            }
         }
         return "";
      }
      
      function setBootstrapModal() {
       var modal = getCookie("modal");
       /*Check if modal cookie is set or not*/
       if (modal != "") {
          /*if cookie is set lets hide the modal*/
          $('#optinForm').modal('hide');
       }
       else {
          /*if cookie is not set lets show the modal for once*/
          $('#optinForm').modal('show'); 
          setCookie("modal", 'hide', 1);
       }
    }
      
      setBootstrapModal(); 
    });  

 
